import type { RequestParameter } from "../../DropdownDimensionHelpers";

import type {
    DataDimensionInput,
    DataDimensionValueBaseConfig,
} from "./dimension.data.value";
import {
    DataDimensionValue,
    DataDimensionValueType,
} from "./dimension.data.value";

export interface DataDimensionValueRequestParameterConfig
    extends DataDimensionValueBaseConfig {
    type: DataDimensionValueType.REQUEST_PARAMETER;
}

export class DataDimensionValueRequestParameter extends DataDimensionValue {
    constructor(
        dimensionId: string,
        config: DataDimensionValueRequestParameterConfig,
    ) {
        super(dimensionId, config);
        this.config = config;
    }

    type = DataDimensionValueType.JSON;
    config: DataDimensionValueRequestParameterConfig;

    protected handler(input: DataDimensionInput): string {
        return JSON.stringify(input);
    }

    getRequestParameter(input: DataDimensionInput): RequestParameter {
        if (typeof input !== "object") {
            throw new Error(
                "data dimension - value - request parameter can only have object as a datasource",
            );
        }
        return {
            ...input,
        };
    }
}
